<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card>
      <v-row justify="center" dense>
        <v-col sm="3"></v-col>
        <v-col sm="3">
          <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
          <v-combobox dense required v-model="academicyear" :items="ay_list" item-text="ay" item-value="id"
            label="Academic Year" rounded outlined persistent-hint hint="Please Select Academic Year"
            @change="getData()" />
        </v-col>
        <v-col sm="3"></v-col>
      </v-row>
    </v-card>
    <br>
    <v-card v-if="this.childrenList != ''">
      <v-data-table :headers="headers" :items="childrenList" :search="search" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Leave Applications</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
          </v-toolbar>
        </template>

        <template v-slot:[`item.attachments`]="{ item }">
          <span v-if="item.attachments != null">
            <a target="_blank" :href="basepath + item.attachments">Attachment</a>
          </span>
          <span v-else>-</span>
        </template>
      </v-data-table>
    </v-card>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    overlay: false,
    childrenList: [],
    // extraBreadcrumbItems: [

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    ay_list: [],
    search: '',
    academicyear: '',
    snackbar_msg: "",
    color: "",
    snackbar: false, basepath: null,
    headers: [
      { text: "Child Name", value: "Student_Name", sortable: true },
      { text: "Roll No", value: "Roll_No", sortable: true },
      { text: "Registration No", value: "Registration_No", sortable: true },
      { text: "Standard", value: "Standard", sortable: true },
      { text: "Division", value: "Division", sortable: true },
      { text: "Reason", value: "Reason", sortable: true },
      { text: "From", value: "From", sortable: true },
      { text: "To", value: "To", sortable: true },
      { text: "Attachment", value: "attachments", sortable: true }
    ],
  }),
  mounted() {
    this.onLoad();
    this.basepath = localStorage.getItem("awspath");
  },
  methods: {
    onLoad() {
      axios
        .post("App/getAcademicYear")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.ay_list = res.data.ay_list;

            this.overlay = false;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getData() {
      this.childrenList = [];
      const data = {
        ay: this.academicyear.id,
      };
      this.overlay = true;
      axios
        .post("/Academics/getLeaveData", data)
        .then(res => {
          if (res.data.msg == "200") {
            this.overlay = false;
            if (res.data.studentList.length != 0) {
              this.childrenList = res.data.studentList
            }
            else {
              this.showSnackbar("#b71c1c", "No Leave Applications Found!"); // show snackbar on error
            }
          }
          else {
            this.showSnackbar("#b71c1c", "Something went wrong!"); // show snackbar on error
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong!"); // show snackbar on error
          window.console.log(error);
        })
        .finally(() => {
          'use strict';
          var overlay = false
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  }
};
</script>